import React, { useContext } from 'react';
import { Dashboard } from './dashboard';
import LiteModeBanner from '../../components/liteMode/liteMode';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import Loading from '../../components/shared/Loading/Loading';

export const DashboardWrapper = () => {
  const { cspConfiguration, isCspConfigLoading } = useContext(FeatureFlagContext);
  if (isCspConfigLoading) {
    return <Loading />;
  }

  const isLiteModeEnabled = cspConfiguration?.IsLiteModeEnabled;
  const isLiveVetEnabled = cspConfiguration?.IsLiveVetEnabled;

  return isLiteModeEnabled ? <LiteModeBanner isLiveVetEnabled={isLiveVetEnabled} /> : <Dashboard />;
};
